module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "story-text ParaOverride-2"
  }, [_vm._v("Dear Reader,")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t"
  }, [_vm._v("I can’t wait for you to get into this not so “once upon a time” tale of love, life, and low self-esteem. In case the cover didn’t give it away, I am a Muslim woman who wears the hijab. That means I cover my hair in public and also wear long, loose clothing to cover the shape of my body. ")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t"
  }, [_vm._v("Because I consider my character an extension of myself, I have made the personal choice to never draw her without hijab. I bring this up because I don’t want you to be confused when you see my character sleeping or going to the salon in her hijab and mistakenly assume that it’s normal hijabi behavior. SO, for the record:")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3 t"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do not ")]), _vm._v("shower with it on.")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do not")]), _vm._v(" sleep with it on.")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do")]), _vm._v(" take it off to get my hair done.")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do")]), _vm._v(" take it off at “ladies only” weddings.")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do not")]), _vm._v(" cover when I’m at home.")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-3"
  }, [_vm._v("I "), _c('span', {
    staticClass: "bold-bagatela _idGenCharOverride-1"
  }, [_vm._v("do not")]), _vm._v(" cover in front of my husband. ")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t"
  }, [_vm._v("I also want to mention that arranged marriages come in many shapes and sizes. Some couples meet before they wed, while others might not see their betrothed until the day of. Arranged marriages are not to be confused with forced marriages. Contrary to popular belief, forced marriages are not allowed in Islam. ")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t"
  }, [_vm._v("And, this really should go without saying, but say it I shall: this book is specifically about "), _c('span', {
    staticClass: "text-italic"
  }, [_vm._v("my")]), _vm._v(" life experiences and should not be used to make assumptions or generalizations about Muslims as a whole. We are not a monolith. Please remember that, just like with anything else, experiences vary from person to person and culture to culture. ")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t"
  }, [_vm._v("Thank you for reading! And if you’re like me and usually skip the preface of a book, enjoy being confused about Huda wearing a hijab to bed. ")]), _vm._v(" "), _c('p', {
    staticClass: "story-text ParaOverride-2 t2"
  }, [_vm._v("Sincerely,")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1l"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "alt": "",
      "src": "image/sig.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71d07669","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Arranged_ebook2.vue
// module id = 66
// module chunks = 0